module.exports = "/assets/data/809b7547cd8933a837178e00a6cda7a2-NP26.data.json";